import React from 'react';
import { Badge } from './ui/badge';

/**
 * GeoFlag — Badge with a country flag icon.
 * Uses flag-icons CSS library loaded via CDN in index.html.
 * 
 * @param {string} geo — ISO 3166-1 alpha-2 country code (e.g. "BR", "US")
 */
const GeoFlag = ({ geo, className = '' }) => {
    if (!geo) return null;
    const code = geo.toLowerCase();

    return (
        <Badge
            variant="outline"
            className={`text-[11px] font-normal uppercase py-0.5 h-5 flex items-center gap-1 ${className}`}
        >
            <span
                className={`fi fi-${code}`}
                style={{
                    width: 16,
                    height: 12,
                    borderRadius: 3,
                    overflow: 'hidden',
                    display: 'inline-block',
                }}
            />
            <span>{geo}</span>
        </Badge>
    );
};

export default GeoFlag;
